import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const VideoOverlay: React.FC = () => {
  const navigate = useNavigate();
  const [isMuted, setIsMuted] = useState(true);
  const [showSoundButton, setShowSoundButton] = useState(false);

  const orderButtonColor = 'rgba(16, 185, 129, 0.5)';
  const orderLink = 'https://www.clover.com/online-ordering/plinkpos'
  const learnMoreLink = 'https://linktr.ee/clovercanada'

  const handleOrderClick = () => {
    // window.open('https://www.clover.com/online-ordering/plinkpos', '_blank');
    window.location.href = orderLink
  };

  // 添加 useEffect 钩子来控制页面滚动
  useEffect(() => {
    // 保存原始的 overflow 样式
    const originalStyle = window.getComputedStyle(document.body).overflow;
    
    // 禁用滚动
    document.body.style.overflow = 'hidden';
    
    // 组件卸载时恢复原始样式
    return () => {
      document.body.style.overflow = originalStyle;
    };
  }, []);

  useEffect(() => {
    // 添加动画的样式
    const style = document.createElement('style');
    style.innerHTML = `
      @keyframes pulse {
        0% { transform: scale(1); opacity: 1; }
        50% { transform: scale(1.1); opacity: 0.8; }
        100% { transform: scale(1); opacity: 1; }
      }
    `;
    document.head.appendChild(style);

    // 清理函数
    return () => {
      document.head.removeChild(style);
    };
  }, []);

  const videoURL = new URL('https://www.tiktok.com/player/v1/7478044194783644933')
  // const videoURL = new URL('https://www.tiktok.com/@scout2015/video/6718335390845095173')
  videoURL.searchParams.set('autoplay', '1')
  videoURL.searchParams.set('loop', '1')
  videoURL.searchParams.set('rel', '0')
  videoURL.searchParams.set('native_context_menu', '0')
  
  videoURL.searchParams.set('controls', '0')
  videoURL.searchParams.set('progress_bar', '0')
  videoURL.searchParams.set('fullscreen_button', '0')
  videoURL.searchParams.set('timestamp', '0')
  videoURL.searchParams.set('play_button', '0')
  videoURL.searchParams.set('volume_control', '0')
  videoURL.searchParams.set('closed_caption', '0')

  window.addEventListener('message', (event) => {
    console.debug("tiktok message", event);
    if (event.origin !== 'https://www.tiktok.com') {
      return;
    }

    const data = event.data;
    if (!data["x-tiktok-player"]) {
      return;
    }

    const iframe = document.querySelector("iframe");
    if (!iframe) {
      console.error("Tiktok iframe not found");
      return;
    }

    const contentWindow = iframe.contentWindow;
    if (!contentWindow) {
      console.error("Tiktok iframe content window not found");
      return;
    }

    switch(event.data.type) {
      case 'onPlayerReady':
        setShowSoundButton(true);
        break;
      default:
        break;
    }
  });

  

  const handleTouch = (e: React.MouseEvent) => {
    console.log("touchstart");
    const iframe = document.querySelector("iframe");
    if (!iframe) {
      console.error("Tiktok iframe not found");
      return;
    }

    const contentWindow = iframe.contentWindow;
    if (!contentWindow) {
      console.error("Tiktok iframe content window not found");
      return;
    }

    // 设置静音状态
    if (isMuted) {
      // 先播放，然后再取消静音
      contentWindow.postMessage({type: "play", "x-tiktok-player": true}, '*');
      
      // 添加延迟，确保播放命令执行后再取消静音
      setTimeout(() => {
        contentWindow.postMessage({type: "unMute", "x-tiktok-player": true}, '*');
        setIsMuted(false);
      }, 100);
    } else {
      contentWindow.postMessage({type: "mute", "x-tiktok-player": true}, '*');
      setIsMuted(true);
    }

    // 获取按钮元素的位置和大小
    const button = e.currentTarget as HTMLElement;
    const buttonRect = button.getBoundingClientRect();
    
    // 获取点击事件的位置
    const clickX = e.clientX;
    const clickY = e.clientY;
    
    // 创建并分发一个模拟的点击事件到 iframe 的位置
    const iframeRect = iframe.getBoundingClientRect();
    const iframeX = clickX - iframeRect.left;
    const iframeY = clickY - iframeRect.top;
    
    // 将事件传递到 iframe
    // 方法1：创建一个透明的 iframe 覆盖层
    const clickEvent = new MouseEvent('click', {
      bubbles: true,
      cancelable: true,
      view: window,
      clientX: clickX,
      clientY: clickY
    });
    
    // 防止事件冒泡，停止事件传播
    e.stopPropagation();
    
    // 手动分发事件到 iframe
    setTimeout(() => {
      // 尝试点击 iframe 的内容
      try {
        // 使用 postMessage 告诉 iframe 在特定位置模拟点击
        contentWindow.postMessage({
          type: "simulateClick",
          x: iframeX,
          y: iframeY,
          "x-tiktok-player": true
        }, '*');
      } catch (error) {
        console.error("无法向 iframe 发送点击事件:", error);
      }
    }, 10);
  };

  return (
    <div className="absolute h-screen w-full overflow-hidden bg-black">
      {/* 底层：视频页面 */}
      <div className="absolute inset-0 z-0 bg-black">
          <iframe 
            height="100%"
            width="100%"
            src={videoURL.toString()}
            allowFullScreen={false}
            title="Clover System"
            style={{
              zIndex: 0,
              border: 'none',
              pointerEvents: 'auto'
            }}
            allow="autoplay; fullscreen; encrypted-media; picture-in-picture; web-share"
          >
          </iframe>
          {/* <script async src="https://www.tiktok.com/embed.js"></script> */}
      </div>

      {/* 顶层：覆盖层 */}
      <div className="absolute inset-0 z-10 pointer-events-none">
        {/* 添加声音按钮 */}
        <div hidden={!showSoundButton}
          style={{
          position: 'fixed',
          top: '50%',
          transform: 'translateY(-50%)',
          right: '0.5rem',
          pointerEvents: 'auto',
          zIndex: 20
        }}>
          <button
            hidden={!showSoundButton}
            onClick={handleTouch}
            style={{
              width: '50px',
              height: '50px',
              backgroundColor: 'rgba(0, 0, 0, 0.3)',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              border: '2px solid rgba(255, 255, 255, 0.7)',
              cursor: 'pointer',
              animation: isMuted ? 'pulse 1.5s infinite' : 'none',
              pointerEvents: 'auto'
            }}
            aria-label={isMuted ? "Click to enable sound" : "Click to mute"}
          >
            {isMuted ? (
              <svg 
                width="36" 
                height="36" 
                viewBox="0 0 24 24" 
                fill="none" 
                xmlns="http://www.w3.org/2000/svg"
              >
                <path 
                  d="M11 5L6 9H3V15H6L11 19V5Z" 
                  fill="white" 
                  stroke="white" 
                  strokeWidth="2" 
                  strokeLinecap="round" 
                  strokeLinejoin="round"
                />
                <path 
                  d="M23 9L17 15" 
                  stroke="white" 
                  strokeWidth="2" 
                  strokeLinecap="round" 
                  strokeLinejoin="round"
                />
                <path 
                  d="M17 9L23 15" 
                  stroke="white" 
                  strokeWidth="2" 
                  strokeLinecap="round" 
                  strokeLinejoin="round"
                />
              </svg>
            ) : (
              <svg 
                width="36" 
                height="36" 
                viewBox="0 0 24 24" 
                fill="none" 
                xmlns="http://www.w3.org/2000/svg"
              >
                <path 
                  d="M14.5 8.7C14.5 8.7 16 10.4 16 12C16 13.6 14.5 15.3 14.5 15.3" 
                  stroke="white" 
                  strokeWidth="2" 
                  strokeLinecap="round" 
                  strokeLinejoin="round"
                />
                <path 
                  d="M17.5 6C17.5 6 20 8.8 20 12C20 15.2 17.5 18 17.5 18" 
                  stroke="white" 
                  strokeWidth="2" 
                  strokeLinecap="round" 
                  strokeLinejoin="round"
                />
                <path 
                  d="M11 5L6 9H3V15H6L11 19V5Z" 
                  fill="white" 
                  stroke="white" 
                  strokeWidth="2" 
                  strokeLinecap="round" 
                  strokeLinejoin="round"
                />
              </svg>
            )}
          </button>
          {isMuted && (
            <div style={{
              position: 'absolute',
              top: '100%',
              right: 0,
              backgroundColor: 'rgba(0, 0, 0, 0.7)',
              color: 'white',
              padding: '4px 8px',
              borderRadius: '4px',
              fontSize: '14px',
              whiteSpace: 'nowrap',
              marginTop: '4px',
              pointerEvents: 'none'
            }}>
              Click to enable sound
            </div>
          )}
          
          {/* 添加"了解更多"按钮 */}
          <button
            onClick={() => {
              window.location.href = learnMoreLink;
            }}
            style={{
              position: 'absolute',
              top: 'calc(100% + 40px)',
              right: 0,
              backgroundColor: 'rgba(59, 130, 246, 0.4)',
              color: 'white',
              padding: '8px 12px',
              borderRadius: '4px',
              fontSize: '14px',
              whiteSpace: 'nowrap',
              border: '1px solid rgba(255, 255, 255, 0.5)',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center', 
              transition: 'all 300ms',
              pointerEvents: 'auto'
            }}
            onMouseOver={(e) => e.currentTarget.style.backgroundColor = 'rgba(59, 130, 246, 0.9)'}
            onMouseOut={(e) => e.currentTarget.style.backgroundColor = 'rgba(59, 130, 246, 0.4)'}
          >
            点此了解更多
            <svg 
              width="16" 
              height="16" 
              viewBox="0 0 24 24" 
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style={{ marginLeft: '4px' }}
            >
              <path 
                d="M5 12H19" 
                stroke="white" 
                strokeWidth="2" 
                strokeLinecap="round" 
                strokeLinejoin="round"
              />
              <path 
                d="M12 5L19 12L12 19" 
                stroke="white" 
                strokeWidth="2" 
                strokeLinecap="round" 
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>

        <div className="p-4">
          <button
            onClick={handleOrderClick}
            style={{
              position: 'fixed',
              bottom: '2rem',
              left: '50%',
              width: '75%',
              transform: 'translateX(-50%)',
              backgroundColor: orderButtonColor,
              color: 'black',
              fontSize: '1.875rem',
              fontWeight: 'bold',
              paddingLeft: '3.5rem',
              paddingRight: '3.5rem',
              paddingTop: '1.5rem',
              paddingBottom: '1.5rem',
              borderRadius: '9px',
              boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
              transition: 'all 300ms',
              pointerEvents: 'auto'
            }}
            onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#34D399'}
            onMouseOut={(e) => e.currentTarget.style.backgroundColor = orderButtonColor}
          >Order Here
          </button>
        </div>
      </div>
    </div>
  );
};

export default VideoOverlay;
